import angular from 'angular';
import {SftpServersListController} from './sftp-servers-list.controller.js';
import {SftpServerEditionController} from './sftp-server-edition.controller.js';
import {SftpServersService} from './sftp-servers.service.js';

angular
  .module('parameters.sftp-servers', [])
  .controller('SftpServersListController', SftpServersListController)
  .controller('SftpServerEditionController', SftpServerEditionController)
  .factory('SftpServersFactory', SftpServersService.SftpServersFactory)
